(ns common.schema.entities.ai-usage-event
  "One row per AI provider call: which service/provider handled which task-type,
   and the token counts the provider reported. Written by the AI processing
   worker (backend.domain.ai.processing); read by tenant admins for usage
   visibility. Timestamp is :common/created-on."
  (:require [common.schema.entities.integration.ai-options :as ai-options]
            [common.schema.schema-utils :as su]))

(def schema
  (vec
   (concat
    (su/keyword-field :ai-usage-event/task-type "Task type" ai-options/task-type-options
                      {:authorization su/access-admin-admin})
    (su/keyword-field :ai-usage-event/provider "Provider" ai-options/provider-options
                      {:authorization su/access-admin-admin})
    (su/single-ref-field :ai-usage-event/service "AI service"
                         [:entity.type/ai-service]
                         {:authorization su/access-admin-admin})
    (su/single-ref-field :ai-usage-event/task "Task"
                         [:entity.type/task]
                         {:authorization su/access-admin-admin})
    (su/long-field :ai-usage-event/prompt-tokens "Prompt tokens"
                   {:authorization su/access-admin-admin})
    (su/long-field :ai-usage-event/completion-tokens "Completion tokens"
                   {:authorization su/access-admin-admin}))))
